import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import type { Gebied } from '@models/Gebied'

import { useAuthenticatedUser } from '../../../../auth/hooks/useAuthenticatedUser'
import { initialState } from '../../../../opdrachten/services/searchOpdrachten'
import type { Werkbak } from '../../../../opdrachten/types/Werkbak'
import { Grid } from '../../../../theme/components/Grid'
import { useWerkbakken } from '../../hooks/useWerkbakken'

import { WerkbakTile } from './WerkbakTile'
import { WerkbakkenFilters } from './WerkbakkenFilters'

interface Props {
  filterOptions: {
    netbeheerders: string[]
    uitvoerendeAannemers: string[]
    gebieden: Gebied[]
  }
  onClickTile: (query: any, url: any) => void
}

export const Werkbakken = ({ onClickTile, filterOptions }: Props) => {
  const {
    data: werkbakken,
    onChangeFilters,
    filters,
    initialFilters,
    onRefresh,
    onReset,
  } = useWerkbakken()
  const { canViewOpdrachten } = useAuthenticatedUser()

  const handleClickTile = (werkbak: Werkbak) => {
    const { label, code } = werkbak

    onClickTile(
      {
        filters: {
          ...initialState.query.filters,
          ...filters,
          werkbak: { code, label },
        },
        page: initialState.query.page,
        sort: initialState.query.sort,
      },
      '/opdrachten',
    )
  }

  return canViewOpdrachten ? (
    <>
      <WerkbakkenFilters
        onChange={onChangeFilters}
        filters={filters}
        initialFilters={initialFilters}
        filterOptions={filterOptions}
        onRefresh={onRefresh}
        onReset={onReset}
      />

      <Box sx={{ p: '50px', ml: '20px' }}>
        {['Netbeheerder', 'Aannemer', 'Uitval'].map((group) => (
          <Accordion sx={{ width: '100%' }} defaultExpanded key={group}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ fontSize: '24px', pl: '24px' }}>
                {group}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                {werkbakken
                  .filter((werkbak) => werkbak.deelnemer === group)
                  .map((wb) => (
                    <Grid key={wb.code}>
                      <WerkbakTile werkbak={wb} onClickTile={handleClickTile} />
                    </Grid>
                  ))}
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </>
  ) : null
}
